<template>
  <edit-pwd :form="form"
            @editpwdcallback="editpwdcallback"></edit-pwd>
</template>

<script>
import { mapActions } from 'vuex'
import EditPwd from '../../components/editPwd'
export default {
  name: 'userRootGroupMain',
  components: { EditPwd },
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.fUsrPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      form: {
        fUsrID: '',
        fUsrNo: '',
        fUsrPwdOld: '',
        fUsrPwd: '',
        checkPass: '',
        fUsrName: ''
      },
      isDisabled: true,
      formLabelWidth: '120px',
      rules: {
        fUsrPwdOld: [
          { required: true, message: '请输入用户密码', trigger: 'blur' },
          { min: 6, max: 60, message: '长度为6到60个字符', trigger: 'blur' }
        ],
        fUsrPwd: [
          { required: true, message: '请输入用户密码', trigger: 'blur' },
          { min: 6, max: 60, message: '长度为8到60个字符', trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    ...mapActions([
      'getCurrentUser', 'editCurrentUserPwd'
    ]),
    editpwdcallback () {
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editCurrentUserPwd(this.form).then(res => {
            if (res && res.data) {
              let { status, data } = res
              if (status !== 200) {
                this.$message({
                  type: 'error',
                  message: '用户操作出错'
                })
              } else {
                if (!data.IsOk) {
                  this.$message({
                    type: 'error',
                    message: data.Msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '修改密码成功'
                  })
                }
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  },
  created () {
  },
  mounted () {
    this.getCurrentUser().then(res => {
      let { status, data } = res
      if (status === 200) {
        if (data.IsOk) {
          Object.assign(this.form, data.Data)
          this.form.fUsrPwd = ''
        }
      }
    })
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/user/editUserPwd.vue